import React, { Component } from 'react';
import './ReviewApplicants.css';

import FlatButton from 'material-ui/FlatButton';

import { MdCheckCircle as VerifiedIcon } from 'react-icons/md';
import { MdRemoveCircle as UnverifiedIcon } from 'react-icons/md';

import { AccentColor } from 'helpers/AccentColorHelper';
import { formatPhone } from 'helpers/Formatter';

class PersonalReference extends Component {
  verifiedIcon(applicant) {
    if (applicant.verified) {
      return <VerifiedIcon style={{ color: '#3dce3d' }} />;
    } else {
      return <UnverifiedIcon style={{ color: AccentColor() }} />;
    }
  }

  lengthOfRelationship(applicant) {
    return `They've known each other for ${applicant.duration}.`;
  }

  render() {
    const style = {
      row: {
        padding: '0 15px',
        marginTop: '30px',
      },
      half_width: {
        width: '50%',
        verticalAlign: 'initial',
      },
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
        overflowWrap: 'break-word',
      },
      sub_header_last: {
        marginTop: '10px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      edit_delete_buttons: {
        padding: '15px 0px 0 0',
        textAlign: 'left',
      },
      edit_row: {
        padding: '0 15px',
        marginTop: '30px',
        textAlign: 'center',
      },
      name_header: {
        fontSize: '18px',
        color: '#6F6F6F',
        marginTop: '5px',
        marginBottom: 0,
        height: 'initial',
      },
      relationship_header: {
        fontSize: '14px',
        height: '31px',
        color: '#6F6F6F',
        marginTop: '-17px',
        marginBottom: '-5px',
      },
      email_header: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
      },
      phone_number_header: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
      },
      length_of_stay: {
        fontSize: '14px',
        height: '31px',
        color: '#6F6F6F',
        marginTop: '-15px',
      },
      button_container: {
        padding: '30px 15px 10px 15px',
        textAlign: 'center',
      },
      button: {
        backgroundColor: AccentColor(),
        color: '#fff',
      },
      select_field_label: {
        backgroundColor: AccentColor(),
        color: '#fff',
      },
      underline: {
        borderColor: '#fff',
        bottom: 0,
      },
      underline_focus: {
        borderColor: '#f7f7f7',
        bottom: 0,
      },
      text_field_input: {
        height: 'initial',
        color: '#6F6F6F',
      },
      padding_left: {
        padding: '15px 0px 0 0',
        textAlign: 'left',
      },
      titleContentStyle: {
        borderBottom: '0px solid #e0e0e0',
        padding: '20px 20px 5px 20px',
        textAlign: 'center',
        color: '#4e4e4e',
      },
      customContentStyle: {
        maxWidth: '400px',
        width: '95%',
      },
      bodyContentStyle: {
        padding: '10px 20px 20px 20px',
        textAlign: 'center',
      },
      deletebodyContentStyle: {
        padding: '20px 5px 0px 5px',
        textAlign: 'center',
      },
      quote: {
        margin: '10px',
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    let personal_references;
    if (this.props.applicant_data.length !== 0) {
      personal_references = Object.keys(this.props.applicant_data).map((key) => (
        <div key={key} className="row" style={style.row}>
          <div className="wrapper">
            <h5 style={style.header}>
              {this.props.applicant_data[key].name}
              <span style={{ verticalAlign: 'super', marginLeft: '3px' }}>
                {this.verifiedIcon(this.props.applicant_data[key])}
              </span>
            </h5>
            <h5 style={style.sub_header}>{this.props.applicant_data[key].relationship}</h5>
            <h5 style={style.sub_header}>{this.props.applicant_data[key].email}</h5>
            <h5 style={style.sub_header}>
              {formatPhone(this.props.applicant_data[key].phone_number)}
            </h5>

            <div className="second">
              <h5 style={style.header}> Personal Reference </h5>
              <h5 style={style.sub_header}>
                {' '}
                {this.props.applicant_data[key].verified ? 'Verified!' : 'Pending Verification'}
              </h5>
              {this.props.applicant_data[key].verified &&
                this.props.applicant_data[key].reference_text && (
                  <div style={style.quote}>
                    {' '}
                    &ldquo; {this.props.applicant_data[key].reference_text} &rdquo;{' '}
                  </div>
                )}
              <h5 style={style.sub_header_last}>
                {' '}
                {this.lengthOfRelationship(this.props.applicant_data[key])}{' '}
              </h5>
            </div>
          </div>

          <div className="row" style={style.button_container}>
            {!this.props.applicant_data[key].verified && (
              <FlatButton
                label={<span>Verify Reference</span>}
                onClick={() => {
                  this.props.approveReference(
                    this.props.applicantId,
                    'personal_references',
                    this.props.applicant_data[key].id
                  );
                }}
                primary={true}
                style={style.button}
              />
            )}
          </div>
        </div>
      ));
    } else {
      personal_references = (
        <div className="small-message">
          <small>Waiting on application.</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Personal References </h5>
        </div>

        {personal_references}
      </div>
    );
  }
}

export default PersonalReference;
